import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Icon } from 'meinian-package/src/component'
import styles from './index.module.less'

export default () => {
  const history = useNavigate()
  return <div style={{ textAlign: 'center' }}>
    <Icon
      type="m-logo"
      className={styles.logo}
      onClick={() => {
        history('/home/workbench/index')
      }}
    />
  </div>
}
